/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorActionLogDto } from '../../models/create-vendor-action-log-dto';
import { VendorActionLogDto } from '../../models/vendor-action-log-dto';

export interface VendorActionLogControllerCreate$Params {
      body: CreateVendorActionLogDto
}

export function vendorActionLogControllerCreate(http: HttpClient, rootUrl: string, params: VendorActionLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorActionLogControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorActionLogDto>;
    })
  );
}

vendorActionLogControllerCreate.PATH = '/api/vendorActionLLog';
